<div class="spacerWrapper" fxLayout="column">
    <h1 mat-dialog-title class="dialogTitle">{{ title }}</h1>

    <div mat-dialog-content>
        <form [formGroup]="roleEditorForm" class="grid-container">
            <div class="inputContainer userRole">
                <label>Role</label>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="RoleName" />
                </mat-form-field>
            </div>
        </form>
    </div>

    <div class="spacer" fxFlexFill></div>
    <div class="actions">
        <div class="error-messages" fxLayout="column" fxLayoutAlign="start end">
            <mat-error *ngIf="Role.invalid && !Role.errors?.isRoleTaken && Role.touched">
                <mat-icon aria-hidden="false" aria-label="Error: Missing Role">error</mat-icon>
                Missing Role Name.
            </mat-error>
            <mat-error *ngIf="Role.errors?.isRoleTaken && Role.touched">
                <mat-icon aria-hidden="false" aria-label="Error: Role name chosen is already taken.">error</mat-icon>
                Role name chosen is already taken.
            </mat-error>
        </div>

        <div mat-dialog-actions align="end">
            <button mat-raised-button type="submit" color="primary" (click)="onSubmit(roleEditorForm.value)">OK</button>
            <button mat-raised-button type="button" (click)="onNoClick()">Cancel</button>
        </div>
    </div>
</div>
